import {
	getVariables as _getVariables,
	type UseIssuesInput,
} from '@atlassian/jira-business-common';

const DEFAULT_CHILDREN_PER_PAGE = 100;

export const getVariables = (input: UseIssuesInput) => {
	const overriddenVariables = input.parentIssue ? { first: DEFAULT_CHILDREN_PER_PAGE } : {};

	return { ..._getVariables(input), ...overriddenVariables };
};
